import { render } from "./omoListItem.vue?vue&type=template&id=6bd07724&scoped=true&ts=true"
import script from "./omoListItem.vue?vue&type=script&lang=ts"
export * from "./omoListItem.vue?vue&type=script&lang=ts"

import "./omoListItem.vue?vue&type=style&index=0&id=6bd07724&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd07724"]])

export default __exports__